const HA_TO_ACRE_RATIO = 2.47;

/**
 * Convert hectares to acres
 * Caller must filter null/NaN before calling
 * @param {number} hectares - Valid hectare value
 * @returns {number} Value in acres (rounded to 2 decimals)
 */
export const convertHaToAcre = (hectares) => {
  return Number((hectares * HA_TO_ACRE_RATIO).toFixed(2));
};

/**
 * Convert acres to hectares
 * Caller must filter null/NaN before calling
 * @param {number} acres - Valid acre value
 * @returns {number} Value in hectares (rounded to 2 decimals)
 */
export const convertAcreToHa = (acres) => {
  return Number((acres / HA_TO_ACRE_RATIO).toFixed(2));
};

/**
 * Convert any per-hectare metric to per-acre
 * Caller must filter null/NaN before calling
 * e.g., stand count per hectare, yield density per hectare
 * @param {number} valuePerHa - Valid value measured per hectare
 * @returns {number} Value measured per acre (rounded to 2 decimals)
 */
export const convertPerHaToPerAcre = (valuePerHa) => {
  return Number((valuePerHa / HA_TO_ACRE_RATIO).toFixed(2));
};

/**
 * Convert any per-acre metric to per-hectare
 * Caller must filter null/NaN before calling
 * e.g., stand count per acre, yield density per acre
 * @param {number} valuePerAcre - Valid value measured per acre
 * @returns {number} Value measured per hectare (rounded to 2 decimals)
 */
export const convertPerAcreToPerHa = (valuePerAcre) => {
  return Number((valuePerAcre * HA_TO_ACRE_RATIO).toFixed(2));
};

/**
 * Get area unit label based on setting
 * @param {string} areaUnit - 'Hectare' or 'acre'
 * @returns {string} Unit label for display ('Ha' or 'acre')
 */
export const getAreaUnitLabel = (areaUnit) => {
  return areaUnit === "acre" ? "acre" : "Ha";
};

/**
 * Get density unit label (per unit area) based on setting
 * @param {string} areaUnit - 'Hectare' or 'acre'
 * @returns {string} Unit label for display (e.g., 'per acre', 'per Ha')
 */
export const getDensityUnitLabel = (areaUnit) => {
  return areaUnit === "acre" ? "per acre" : "per Ha";
};
